export default "__VITE_ASSET__DbSgwLIC__"